import type { CoordinateCalibration } from '../../types/game'

export interface Point {
  x: number
  y: number
}
export function worldToPixel(
  world: Point,
  calibration: CoordinateCalibration
): Point | null {
  if (calibration.status === 'unverified') return null

  return {
    x: calibration.pixelOriginX
      + (world.x - calibration.worldOriginX) * calibration.pixelsPerWorldX,
    y: calibration.pixelOriginY
      + (world.y - calibration.worldOriginY) * calibration.pixelsPerWorldY
  }
}

export function calibrationFromTwoPoints(
  biome: number,
  firstWorld: Point,
  firstPixel: Point,
  secondWorld: Point,
  secondPixel: Point
): CoordinateCalibration {
  const worldDeltaX = secondWorld.x - firstWorld.x
  const worldDeltaY = secondWorld.y - firstWorld.y
  if (worldDeltaX === 0 || worldDeltaY === 0) {
    throw new Error('两个校准点的世界坐标必须同时具有 X、Y 差异。')
  }

  return {
    biome,
    status: 'manual',
    worldOriginX: firstWorld.x,
    worldOriginY: firstWorld.y,
    pixelOriginX: firstPixel.x,
    pixelOriginY: firstPixel.y,
    pixelsPerWorldX: (secondPixel.x - firstPixel.x) / worldDeltaX,
    pixelsPerWorldY: (secondPixel.y - firstPixel.y) / worldDeltaY
  }
}
